'use client'

import Button from '@eversports/klimt-primitives/Button'
import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

import useClientLogger from '../../lib/rollbar/use-client-logger'
import EversportsLogo from '../../patterns/ViewerRoleGuard/assets/icon.svg'

export default function LocaleError({ error }: { error: Error & { digest?: string } }) {
  const translate = useTranslations('global-error-page')
  const clientLogger = useClientLogger()

  useEffect(() => {
    if (!clientLogger) return
    clientLogger.error(error.message, error)
  }, [error, clientLogger])

  return (
    <main className="flex h-screen flex-col items-center justify-center gap-3 text-center">
      <Image src={EversportsLogo} width={140} height={140} alt="Eversports logo" />
      <h1 className="text-xl">{translate('title')}</h1>
      <p className="max-w-md">{translate('description')}</p>
      <a href="/">
        <Button text={translate('button')} />
      </a>
    </main>
  )
}
